import { Typography } from "@mui/material";
import React from "react";

const NoRecordFound = (props) => {
  if (!Array.isArray(props.data) || props.data.length === 0)
    return (
      <>
        <Typography
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
          // variant="h6"
        >
          No result
        </Typography>
      </>
    );

  return <></>;
};

export default NoRecordFound;
